import { IReservation } from '../shared/interfaces/reservation.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';

class ExtendedHoldReservationServiceClass {
    private static _instance: ExtendedHoldReservationServiceClass;
    public static get instance() {
        return this._instance || (this._instance = new this());
    }
    private constructor() { }

    /**
     * Method to get extended hold reservation object
     * @param hotelCode
     * @param reservation
     */
    async extendedHoldReservation(hotelCode: number, reservation: IReservation,
        loyaltyTierId: number = null, currencyCode?: string, tcShareLocation?: boolean): Promise<IReservation> {
        const requestPayload = JSON.parse(JSON.stringify(reservation));
        try {
            const extendedHoldReservationApiResponse: Response = await ApiService.callExtendedHoldReservation
                (hotelCode, requestPayload, loyaltyTierId, currencyCode, tcShareLocation);
            const extendedHoldReservationObject: IReservation = await extendedHoldReservationApiResponse.json();
            return extendedHoldReservationObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }

    /**
     * Method to get extended hold reservation object
     * @param hotelCode
     * @param reservation
     * @param emailId
     * @param languageId
     */
    async getExtendedHoldReservation(hotelCode: number, reservationCode: number,
        emailId: string, languageId: string, loyaltyTierId: number = null,
        currencyCode?: string, tcShareLocation?: boolean): Promise<IReservation> {
        try {
            const extendedReservationApiResponse: Response = await ApiService.getExtendedReservation
                (hotelCode, reservationCode, emailId, languageId, loyaltyTierId, currencyCode, tcShareLocation);
            const extendedReservationObject: IReservation = await extendedReservationApiResponse.json();
            return extendedReservationObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
    /**
     * Method to cancel reservation
     * @param hotelCode
     * @param reservationCode
     * @param email
    */
    async cancelExtendedHoldReservation(hotelCode: number, reservationCode: number, email: string) {
        try {
            const retrieveReservationApiResponse: Response =
                await ApiService.cancelExtendedHoldReservation(hotelCode, reservationCode, email);
            let response = '';
            if (retrieveReservationApiResponse.status !== 204) {
                response = await retrieveReservationApiResponse.json();
            }
            return response;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const ExtendedHoldReservationService = ExtendedHoldReservationServiceClass.instance;
